import { put } from "redux-saga/effects";
import http from "axios";
import {
  CURRENT_EXCHANGE_RATE,
  UPDATE_RECORDER_EXCHANGE_RATE
} from '../../../api/constants';
import {
  fetchExchangeRateSuccessful,
  fetchExchangeRateFailure
} from '../../actions'
import saveAs from 'react-file-download';
import { swalOpen, swalClose } from "../../utils/index";

import {
SWAL_ERROR_TITLE,
  SWAL_SUCCESS_TITLE,
  SWAL_TYPE_ERROR,
  SWAL_TYPE_SUCCESS,
  PLEASE_WAIT_TITLE,
  INFORMATION_UPDATE_MESSAGE,
  SWAL_TYPE_INFO,
  COST_UPDATE_MESSAGE,

} from '../../../utils/constants';

export function* fetchExchangeRate({ payload }) {
  try {
    const { currency } = payload;
    let body = new URLSearchParams();
    body.append("currency", currency)
    const response = yield http.post(CURRENT_EXCHANGE_RATE, body);
    yield put(fetchExchangeRateSuccessful(response.data.data))
  } catch (error) {
    console.log("Exchange rate alınamadı: ",error)
  }
}
export function* updateExchangeRate({ payload }) {
try {
  const { costData, accessToken, cb } = payload;
  let body = new URLSearchParams();
  body.append("costId", costData.costId)
  body.append("exchangeRate", costData.exchangeRate)
  body.append("accessToken", accessToken)
  swalOpen(PLEASE_WAIT_TITLE, INFORMATION_UPDATE_MESSAGE, SWAL_TYPE_INFO, true);
  const response = yield http.post(UPDATE_RECORDER_EXCHANGE_RATE, body);
  swalOpen(PLEASE_WAIT_TITLE, COST_UPDATE_MESSAGE, SWAL_TYPE_INFO, false);
if(!response.error)
{ swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
  setTimeout(function () {
    window.location.reload()
  }, 1000);
}
else {
  swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
}
} catch (error) {
  console.log("Exchange update olamadı: ",error)
}
}

